/**
 * Top app bar — wordmark on the left, signed-in email + sign-out on
 * the right. Sticky so the curator can always sign out from any scroll
 * position.
 */
import { Link } from 'react-router-dom';

export default function Header({
  email,
  onSignOut,
}: {
  email: string;
  onSignOut: () => void;
}) {
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-3" aria-label="OpenSoi Curator home">
          <span className="inline-block h-9 w-9 rounded-lg bg-soi-500" aria-hidden="true">
            <svg viewBox="0 0 64 64" className="h-9 w-9">
              <path d="M12 32 H52 A20 20 0 0 1 12 32 Z" fill="#fff7ed" />
              <path
                d="M12 32 H52"
                stroke="#7c2d12"
                strokeWidth="2.5"
                strokeLinecap="round"
                fill="none"
              />
              <path
                d="M22 22 q3 -6 6 0 t6 0 t6 0"
                stroke="#fff"
                strokeWidth="2.5"
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </span>
          <div className="flex flex-col leading-tight">
            <span className="text-base font-semibold text-slate-900">OpenSoi</span>
            <span className="text-xs uppercase tracking-wider text-soi-600">Curator</span>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          <span
            className="hidden truncate text-sm text-slate-600 sm:block"
            title={email}
            aria-label="Signed-in email"
          >
            {email}
          </span>
          <button
            type="button"
            onClick={onSignOut}
            className="rounded-md border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-100"
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
